import { render, staticRenderFns } from "./MainBookCompPSCreate.vue?vue&type=template&id=95d0f250"
import script from "./MainBookCompPSCreate.vue?vue&type=script&lang=js"
export * from "./MainBookCompPSCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports